import { render, staticRenderFns } from "./delete-bank.vue?vue&type=template&id=2904c8a1&"
import script from "./delete-bank.vue?vue&type=script&lang=js&"
export * from "./delete-bank.vue?vue&type=script&lang=js&"
import style0 from "./delete-bank.vue?vue&type=style&index=0&id=2904c8a1&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports